export function todaysDate() {
  return new Date().toISOString().substring(0, 10)
}

/**
 * A general purpose function to format a date
 * @returns A formatted date + time string
 */
export function formatDateTime(
  date: Date,
  locale: string = 'en-US',
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }
) {
  return new Date(date).toLocaleDateString(locale, options)
}

/**
 * Takes a date string and formats it to a date string
 * @param date - The date string to format
 * @param locale - The locale to use for formatting
 * @param options - The options to use for formatting
 * @returns A formatted date string
 */
export function formatDate(
  date: string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  },
  locale = 'en-US'
) {
  if (!date) return ''
  return new Date(date).toLocaleDateString(locale, options)
}
